import React from "react";

import { useTranslation } from "utils";

import { Button, Icon } from "components";

type FarmMapZoomControlProps = {
  onZoomIn: () => void;
  onZoomOut: () => void;
};

export const FarmMapZoomControl = ({ onZoomIn, onZoomOut }: FarmMapZoomControlProps) => {
  const { t } = useTranslation("home");

  return (
    <div className="farm-map-zoom">
      <Button dataTestId="farm-map-zoom-in" aria-label={t("farmMap.zoomIn")} title={t("farmMap.zoomIn")} onClick={onZoomIn}>
        <Icon iconName="klim/plus" size="s" />
      </Button>
      <span className="farm-map-zoom-divider" aria-hidden />
      <Button dataTestId="farm-map-zoom-out" aria-label={t("farmMap.zoomOut")} title={t("farmMap.zoomOut")} onClick={onZoomOut}>
        <Icon iconName="klim/minus" size="s" />
      </Button>
    </div>
  );
};
